import React, { useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import Notification from "../../../components/common/notification/Notification";

interface AlertPopupProps {
  open: boolean;
  title?: string;
  onHide?: () => void;
  content?: any;
  isError?: any;
  submitHandler?: () => void;
  yesText?: string;
  noText?: string;
}

const AlertPopup: React.FC<AlertPopupProps> = ({
  open,
  title,
  onHide = () => {},
  content,
  isError,
  submitHandler = () => {},
  yesText,
  noText,
}) => {
  const classes = useStyles();

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition
  return (
    <Popup
      open={open}
      title={title || ''}
      onHide={onHide}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={onHide}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
         {isError ? (
            <CustomButton
              variant="outlined"
              title="Close"
              onClick={onHide}
            />
          ) : (
            <>
              <CustomButton variant="outlined" title={noText || "No"} onClick={onHide} />
              <CustomButton title={yesText || "Yes"} onClick={submitHandler} />
            </>
          )}
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <>
            {isError ? (
              <Notification />
            ) : (
              <Alert
                sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
                severity="warning"
              >
                {content}
              </Alert>
            )}
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default AlertPopup;